import { Box, Typography } from '@mui/material'
import { Variant } from '@mui/material/styles/createTypography'
import React from 'react'


export function Placeholder({ children, variant = 'h5' }: React.PropsWithChildren<{variant?: Variant}>) {
  return (
    <Box p={2}>
      <Typography align="center" color="textSecondary" variant={variant}>{children}</Typography>
    </Box>
  )
}
